const styles = theme => ({
    root: {
      gridColumnStart: 2,
      padding: theme.spacing(5, 0),
    },
    // '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track':{
    //   backgroundColor: '#000'
    // }

    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: '#000',
         
        },
      },
    },
  
  })
  
  export default styles
  